var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import TabTrap from '../../../helpers/TabTrap';
import { Container, FooterContainer, ModalContent, Overlay } from './subcomponents';
const SlideInModal = (_a) => {
    var { id, isOpen, children, header, className, footer, headerRef } = _a, props = __rest(_a, ["id", "isOpen", "children", "header", "className", "footer", "headerRef"]);
    const [postAnimationState, setPostAnimationState] = useState(false);
    useEffect(() => {
        const selectorId = `#${id}`;
        const selectedElement = document.querySelector(selectorId);
        // set focus to the header when modal is opened
        if (isOpen && headerRef.current) {
            headerRef.current.focus();
            // React Ref wasn't working for this case
            selectedElement.style.right = '0px';
            document.body.style.overflow = 'hidden';
            setPostAnimationState(true);
        }
        if (!isOpen && document.querySelector(selectorId)) {
            // React Ref wasn't working for this case
            selectedElement.style.right = '-768px';
            // Remove overflow hidden after modal closes
            document.body.style.removeProperty('overflow');
            setTimeout(() => {
                setPostAnimationState(false);
            }, 400);
        }
        return () => {
            // Clean up overflow style during unmount
            document.body.style.removeProperty('overflow');
        };
    }, [isOpen, headerRef, id]);
    return (_jsx(Overlay, Object.assign({ isOpen: postAnimationState }, { children: (isOpen || postAnimationState) && (_jsx(TabTrap, { children: _jsxs(Container, Object.assign({}, props, { id: id, "aria-hidden": !isOpen, role: "dialog", className: className }, { children: [!!header && header, _jsx(ModalContent, Object.assign({ ref: !header ? headerRef : null, hasFooter: !!footer }, { children: children })), !!footer && _jsx(FooterContainer, { children: footer })] })) })) })));
};
export default SlideInModal;
//# sourceMappingURL=SlideInModal.js.map